import * as React from "react";
function EyeClosedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.269 4.769a.38.38 0 00-.538-.538l-15 15a.38.38 0 00.538.538l15-15zm-9.835.857a12.835 12.835 0 015.98.339l-.615.615a12.102 12.102 0 00-5.233-.206C5.55 7.083 2.246 9.623.96 11.941c1.56 1.7 3.114 2.956 4.636 3.842l-.555.554c-1.597-.956-3.213-2.294-4.823-4.083a.38.38 0 01-.058-.424c1.311-2.622 4.923-5.436 9.274-6.204zM12 8c.417 0 .819.064 1.197.182l-.628.628a3.24 3.24 0 00-3.76 3.76l-.627.627A4 4 0 0112 8zm3.521 2.1l-.567.567a3.24 3.24 0 01-4.287 4.287l-.567.567a4 4 0 005.42-5.42zm-2.137 7.336a11.268 11.268 0 01-4.836-.362l-.607.606c1.918.635 3.784.761 5.55.509 4.06-.58 7.514-3.15 9.803-5.948a.38.38 0 00.007-.473c-1.568-2.029-3.24-3.495-4.945-4.503l-.556.556c1.613.923 3.206 2.278 4.712 4.172-2.208 2.607-5.424 4.914-9.128 5.443z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = React.forwardRef(EyeClosedIcon);
export default ForwardRef;